import { PagePDF } from 'pages/highcharts/pages/PagePDF';

export const pages = {
  coverPage: require('pages/highcharts/pages/CoverPage').CoverPage,
  intro: PagePDF,
  default: PagePDF,
};
